import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const resultsApi = {
  getAll: (params) => (
    params?.exam
      ? api.get(`/results/exam/${params.exam}`).then(unwrap).then((data) => (Array.isArray(data) ? data : data?.results ?? []))
      : api.get('/results', { params }).then(unwrap).then((data) => (Array.isArray(data) ? data : data?.results ?? []))
  ),
  getByExam: (examId) => api.get(`/results/exam/${examId}`).then(unwrap),
  getByStudent: (studentId) => api.get(`/results/student/${studentId}`).then(unwrap),
  getClassRank: (studentId) => api.get(`/results/student/${studentId}/class-rank`).then(unwrap),
  create: (data) => api.post('/results', data).then(unwrap),
  update: (id, data) => api.put(`/results/${id}`, data).then(unwrap),
}
